import React, { useEffect, useState } from "react";
import { HeadingTitle } from "../ModalContainer";
import { Button } from "@mui/material";
import { clearProductsList, CreateMRPLabelActions } from "../../../Actions/ProductionActions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loading from "../../Loading/Loading";

const ConfirmationPrint = ({ close, inventory_id, token, inventory_details }) => {
  const dispatch = useDispatch();
  // console.log("INVENTORY ID: ", inventory_id, token);

  // Create mrp label state
  const { mrp_label, loading: mrp_label_loading } = useSelector(
    (state) => state.MRPLabelPdf
  );

  const [isPrinted, setIsPrinted] = useState(false);

  const handlePrint = () => {
    setIsPrinted(true);
    dispatch(
      CreateMRPLabelActions("inventory_get_mrp_label_pdf", inventory_id, token)
    );
    dispatch(clearProductsList());
  };

  useEffect(() => {
    if (mrp_label && mrp_label?.status === 1 && isPrinted) {
      let pdfFile = mrp_label && mrp_label?.pdf_file;
      if (pdfFile && pdfFile !== "") {
        window.open(pdfFile, "_blank", "noopener,noreferrer");
      } else {
        toast.error("No PDF File Found");
      }
      setIsPrinted(false);
      close();
    } else if (mrp_label && mrp_label?.status === 0 && isPrinted) {
      toast.error(mrp_label && mrp_label?.msg);
      setIsPrinted(false);
    }
  }, [mrp_label, isPrinted, close]);

  return (
    <>
      <HeadingTitle
        title={"Create MRP Label"}
        center={false}
        closeModal={close}
      />
      <div className="confirmation-print">
        <>
          {inventory_details?.data?.current_box?.box_level != null ? (
            <>
              <p>
                Are you sure this box is in level {inventory_details.data.current_box.box_level}? <br />
                Do you still want to download?
              </p>
            </>
          ) : (
            <p>
              Are you sure? <br />
              Do you want to create MRP Label?
            </p>
          )}
        </>
      </div>
      <div className="confirmation-button">
        <Button onClick={handlePrint}>
          {mrp_label_loading ? <Loading loading={mrp_label_loading} /> : "YES"}
        </Button>
        <Button onClick={close}>NO</Button>
      </div>
    </>
  );
};

export default ConfirmationPrint;
